import { ConnectButton } from '@rainbow-me/rainbowkit'
import bg from './imgs/back.gif'
import fg from './imgs/land.jpg'
import dd from './imgs/DERP_TOKEN.png'
import React from 'react'
import Web3 from 'web3'
import {
  useAccount,
  useChainId,
  usePrepareTransactionRequest,
  useSendTransaction,
  useWaitForTransactionReceipt,
} from 'wagmi'
import { parseEther } from 'viem'
import { config, shop } from './config'
import pendingGif from './imgs/pending2.gif'
import derpeItems from './imgs/derp-items.png'
import discord from './imgs/discord.png'
import tg from './imgs/icon--telegram.png'
import x from './imgs/icon--twitter.png'
import closeImg from './imgs/close.png'

const EVENT = "eco"
const itemIds = ["10038","10036","10030","10019","10023","10024","10025","10026","10027","10028","10029"]

// All item IDs for inventory tracking - keep original order
const ALL_ITEM_IDS = [
  101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,
  10001,10002,10003,10004,10005,10006,10007,10008,10009,10010,10011,10012,10013,10014,10015,10016,10017,10018,10019,10020,10021,10022,10023,10024,10025,10026,10027,10028,10029,10030,10031,10032,10033,10034,10035,10036,10037,10038,
  20001,20002,20003,
  30001,30002,30003,30004,30005,30006,30007,30008,30009,30010,30011,30012,30013,30014,30015,30016,30017,30018,30019,30020,30021,30022,30023,30024,30025,30026,30027,30028,30029,
  40001,40002,40003,40004,40005,40006,40007,
  50001,50002,50003,50004,50005,50006,50007,
  60001,60002,60003,60004,60005,60006,60007,60008,60009,60010,60011,60012,60013,60014,60015
].map(id => id.toString())

 // Item name mapping based on your list
 const ITEM_NAMES = {
    // Series 100 - Derp Cards
    "101": "Derpmander",
    "102": "Derptle",
    "103": "Peekuhdewd",
    "104": "Da Misssooor",
    "105": "Da Button",
    "106": "Moar",
    "107": "Derp Vaydar",
    "108": "Yo Duh",
    "109": "Derp Star",
    "110": "D-3RPO",
    "111": "Boba Fud",
    "112": "Derpe Wan",
    "113": "Da Egg",
    "114": "Bebe Yo Duh",
    "115": "Derpmeleon",
    
    // Series 10000 - Posters
    "10001": "Derp Wars Poster",
    "10002": "Derp Cola Poster",
    "10003": "Derp Cola Classic Poster",
    "10004": "Hotter Than Hell Poster",
    "10005": "Derpface Poster",
    "10006": "Shadow Poster",
    "10007": "Metronix Poster",
    "10008": "Derp Wars II Poster",
    "10009": "Derp Wars II Poster - Green Edition",
    "10010": "Derp Wars II Poster - Tatooine Edition",
    "10011": "CNY 2025 - Lantern Poster",
    "10012": "CNY 2025 - Snake Poster",
    "10013": "Superbowl LIX - Chiefs Poster",
    "10014": "Superbowl LIX - Eagles Poster",
    "10015": "Superbowl LIX Poster",
    "10016": "Cult Poster",
    "10017": "Hubble Poster - Edwin Sits",
    "10018": "Hubble Poster",
    "10019": "Boom Poster",
    "10020": "THC Poster",
    "10021": "Tin Hat Catters Poster",
    "10022": "SELLEK SELLEK Poster",
    "10023": "Sonic World Tour Poster",
    "10024": "Berps Poster",
    "10025": "Knives Poster",
    "10026": "Sucker Poster",
    "10027": "Berp Dash Poster",
    "10028": "LSDerp Poster by Clokkworky",
    "10029": "Beibeeeh POster by Clokkworky",
    "10030": "Magpie POster",
    "10031": "Eggs Finance Poster",
    "10032": "Eggs Finance Poster - Easter Edition",
    "10033": "Derpe Easter Poster",
    "10034": "Derpe Master Banner",
    "10035": "Derp Lord Banner",
    "10036": "Da Eggpire Strikes Back Poster",
    "10037": "Derp Wars Poster - May 4th 2025",
    "10038": "Paintswap 4 Year Anniversary Poster",
    
    // Series 20000 - Trophies
    "20001": "Participation Trophy",
    "20002": "Trophy - Berp Dash",
    "20003": "Halloween Trophy 2025",
    
    // Series 30000 - Items
    "30001": "Condom",
    "30002": "Whoopee Cushion",
    "30003": "Mother's Day Mug",
    "30004": "Lamp",
    "30005": "Ruggie Toy",
    "30006": "Candy Bucket",
    "30007": "Halloween Candy",
    "30008": "Turkey Leg",
    "30009": "Gingerbread Man",
    "30010": "Red Ornament",
    "30011": "Hopium Stocking",
    "30012": "Angel Ornament",
    "30013": "Egg Nog",
    "30014": "Gift #1",
    "30015": "Gift #2",
    "30016": "Snowman",
    "30017": "Red Screaming Ornament",
    "30018": "Cousin Eddie the Snowman",
    "30019": "Pisse the Snowman",
    "30020": "Derpmas Sangria",
    "30021": "Devil Ornament",
    "30022": "Derpe Elf",
    "30023": "Gift #3",
    "30024": "Holy Snowman",
    "30025": "Leg Lamp",
    "30026": "Derp in a Box",
    "30027": "Hot Cocoa",
    "30028": "Derpmas Candle",
    "30029": "Abominable Derpman",
    
    // Series 40000 - Cartridges
    "40001": "Berp Dash",
    "40002": "Berp Dash Green",
    "40003": "Berp Dash Gold",
    "40004": "", // Empty name
    "40005": "", // Empty name
    "40006": "Red Derp Quest Cartridge",
    "40007": "Derp Quest Cartridge",
    
    // Series 50000 - Easter Eggs
    "50001": "Derp - Easter Egg",
    "50002": "Berp - Easter Egg",
    "50003": "Derp Token - Easter Egg",
    "50004": "Uppies - Easter Egg",
    "50005": "Easter Egg",
    "50006": "Button - Easter Egg",
    "50007": "Golden - Easter Egg",
    
    // Series 60000 - Derpupus
    "60001": "Red Derpupu",
    "60002": "Yellow Derpupu",
    "60003": "Berp Derpupu",
    "60004": "Uppies Derpupu",
    "60005": "Cult Derpupu",
    "60006": "Blue Derpupu",
    "60007": "Grey Derpupu",
    "60008": "Pink Derpupu",
    "60009": "Purple Derpupu",
    "60010": "Dark Blue Derpupu",
    "60011": "Ruggies Derpupu",
    "60012": "THC Derpupu",
    "60013": "Moth Derpupu",
    "60014": "Brush Derpupu",
    "60015": "Murica Derpupu"
  }
  
  // File name mapping based on your file list with corrected derpupu paths
  const ITEM_FILE_MAPPINGS = {
    // Series 100 - Derp Cards
    "101": "derpmander.PNG",
    "102": "derptle.PNG",
    "103": "peekuhdewd.PNG",
    "104": "misssooor.PNG",
    "105": "button.PNG",
    "106": "moar.png",
    "107": "derpvaydur.png",
    "108": "yoduh.png",
    "109": "derpstar.png",
    "110": "card-d-3rpo.png",
    "111": "card-boba-fud.png",
    "112": "card-derpe-wan.png",
    "113": "card-da-egg.png",
    "114": "card-bebe.gif",
    "115": "card-derpmeleon.png",
    
    // Series 10000 - Posters
    "10001": "derpwarsposter.png",
    "10002": "derpcolaposter2.png",
    "10003": "derpcolaposter-back.png",
    "10004": "hotterthanhell.png",
    "10005": "derpface.png",
    "10006": "shadow-poster.png",
    "10007": "metronix-poster.png",
    "10008": "poster-derp-wars-2.png",
    "10009": "poster-dw2-green.png",
    "10010": "poster-dw2-tatooine.png",
    "10011": "poster-cny-lantern.png",
    "10012": "poster-cny-snake.png",
    "10013": "poster-sb-chiefs.png",
    "10014": "poster-sb-eagles.png",
    "10015": "poster-sb-both.png",
    "10016": "poster-eco-cult.png",
    "10017": "poster-eco-hubble1.png",
    "10018": "poster-eco-hubble.png",
    "10019": "poster-eco-boom.png",
    "10020": "poster-eco-thc1.png",
    "10021": "poster-eco-thc.png",
    "10022": "poster-eco-sellek.png",
    "10023": "poster-eco-sonic.png",
    "10024": "poster-berps-berps.png",
    "10025": "poster-berps-knives.png",
    "10026": "poster-berps-suckers.png",
    "10027": "poster-berps-berpdash.png",
    "10028": "poster-eco-LSDerp.png",
    "10029": "poster-eco-beibeeeh.png",
    "10030": "poster-magpie.png",
    "10031": "poster-eggs.png",
    "10032": "poster-eggs-easter.png",
    "10033": "poster-easter.png",
    "10034": "derpe-emblem.png",
    "10035": "derp-emblem.png",
    "10036": "tposter-derp-wars-3-eggpire.png",
    "10037": "tposter-derp-wars-3.png",
    "10038": "poster-ps.png",
    
    // Series 20000 - Trophies
    "20001": "trophy.png",
    "20002": "trophy-berpdash.png",
    "20003": "20003.png",
    
    // Series 30000 - Items
    "30001": "condom.png",
    "30002": "kush.png",
    "30003": "mug.jpg",
    "30004": "lamp.jpg",
    "30005": "ruggle.png",
    "30006": "30006.png",
    "30007": "30007.png",
    "30008": "30008.png",
    "30009": "30009.jpg",
    "30010": "30010.png",
    "30011": "30011.png",
    "30012": "30012.png",
    "30013": "30013.png",
    "30014": "30014.png",
    "30015": "30015.png",
    "30016": "30016.png",
    "30017": "30017.png",
    "30018": "30018.png",
    "30019": "30019.jpg",
    "30020": "30020.png",
    "30021": "30021.png",
    "30022": "30022.png",
    "30023": "30023.png",
    "30024": "30024.png",
    "30025": "30025.png",
    "30026": "30026.jpg",
    "30027": "30027.jpg",
    "30028": "30028.png",
    "30029": "30029.png",
    
    // Series 40000 - Cartridges
    "40001": "40001.png",
    "40002": "40002.png",
    "40003": "40003.png",
    "40004": "40004.png",
    "40005": "40005.png",
    "40006": "40006.png",
    "40007": "40007.gif",
    
    // Series 50000 - Easter Eggs
    "50001": "egg-derp.png",
    "50002": "egg-berp.png",
    "50003": "egg-derp-token.png",
    "50004": "egg-uppies.png",
    "50005": "egg-easter.png",
    "50006": "egg-red.png",
    "50007": "egg-golden.gif",
    
    // Series 60000 - Derpupus (corrected based on your new file list)
    "60001": "derpupu/derp.PNG", // Red Derpupu
    "60002": "derpupu/derp-token.PNG", // Yellow Derpupu
    "60003": "derpupu/berp.PNG", // Berp Derpupu
    "60004": "derpupu/uppies.PNG", // Uppies Derpupu
    "60005": "derpupu/skully.PNG", // Cult Derpupu
    "60006": "derpupu/blu.PNG", // Blue Derpupu
    "60007": "derpupu/grey.PNG", // Grey Derpupu
    "60008": "derpupu/pink.PNG", // Pink Derpupu
    "60009": "derpupu/purple.PNG", // Purple Derpupu
    "60010": "derpupu/dark-blu.PNG", // Dark Blue Derpupu
    "60011": "derpupu/ruggies.png", // Ruggies Derpupu
    "60012": "derpupu/thc.png", // THC Derpupu
    "60013": "derpupu/moth.png", // Moth Derpupu
    "60014": "derpupu/brush.png", // Brush Derpupu
    "60015": "derpupu/murica.png" // Murica Derpupu
  }

  
  const getTransactionReceipt = (hash, callback= ()=>{}) => {
	  console.log(hash)
	  window.ethereum.request({
		method: "eth_getTransactionReceipt",
		params: [hash]
	  }).then((res)=>{
		if (res == null) {
		  getTransactionReceipt(hash, callback)
		}
		callback(res)
	  }).catch((err)=>{
		console.log(err)
	  })
  }
  
  const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.soniclabs.com'));
  
  export function Web3App (props) {
	const [cost, setCost] = React.useState(100)  
	const [pending, setIsPending] = React.useState(false)
	const [pendingText, setPendingText] = React.useState("Transaction is in process") 
	const { address, isConnected } = useAccount()
	const chainId  = useChainId()
  
	const [networkConfig, setNetworkConfig] = React.useState(config["mainnet"])
	const [activeTab, setActiveTab] = React.useState('shop') // 'shop' or 'inventory'
	const [inventory, setInventory] = React.useState({})
	const [allItemsData, setAllItemsData] = React.useState([]) // Store all items with their balances and supply
	const [isLoadingInventory, setIsLoadingInventory] = React.useState(false)
	const [itemImageCache, setItemImageCache] = React.useState({})
	const [itemSupplyCache, setItemSupplyCache] = React.useState({}) // Cache for item supply data
  
	const sendRequest = (contract, data, callback = ()=>{}, payable = 0, gasAmount=0) => {
	  setIsPending(true)
	
	  if (typeof window.ethereum !== 'object') { 
		
	  } else {
		
	  window.ethereum.request({
		method: "eth_sendTransaction",
		params: [
		  {
			from: address,
			to: contract,
			value: payable,
			data: data,
		  },
		],}).then((hash)=>{
		  getTransactionReceipt(hash,(receipt)=>{
			if (receipt != null) {
			  setIsPending(false)
			  callback()
			}
		  })
		}).catch((err)=>{
		  setIsPending(false)
		})	
	  }
	  
	}
  
	const estimateGas = (contract, data, saveError, callback = ()=>{}, payable = 0) => {
	console.log("estimating gas", payable)
	console.log("window ethereum object", window.ethereum)
	console.log("typeof window ethereum",typeof(window.ethereum))
  
	if (typeof window.ethereum !== 'object') {
	  alert("Please open this page in the Metamask browser")
	
	} else {
  
	  window.ethereum.request(
			{
			  method: "eth_estimateGas",
			  params: [
				{
				  from: address,
				  to: contract,     
				  value: payable,
				  data: data,
				},
			  ],
			}
		  ).then((gasAmount)=>{
			console.log(gasAmount)
			callback(gasAmount)
		  }).catch((err)=>{
  
			saveError(err.data.message)
			alert(err.data.message)
		  })
		  
	  }
	 
  }
	
  
	const derps = new web3.eth.Contract(networkConfig["derps"]["abi"], networkConfig["derps"]["address"])
	const items = new web3.eth.Contract(networkConfig["derpPromoItems"]["abi"], networkConfig["derpPromoItems"]["address"])
	const derpToken = new web3.eth.Contract(networkConfig["derp"]["abi"], networkConfig["derp"]["address"])
	
	const [style, setStyle] = React.useState({backgroundImage: `url(${fg})`})
  
	React.useEffect(() => {
	  if (isConnected && !pending) {
		setStyle({backgroundImage: `url(${fg})`})
	  } else {
		if (pending) {
	
		} else {
		  if (isConnected) {
			setStyle({backgroundImage: `url(${fg})`})
		  } else {
			setStyle({backgroundImage: `url(${fg})`})
		  }
		  
		}
	  }
	}, [pending, isConnected])
  
	const [bal, setBal] = React.useState(0)
	const getBal = () => {
	  derps.methods.balanceOf(address)
		.call({from: address})
		.then((balance)=>{
		  setBal(balance)
		})
	}
  
	// Function to get item image URL
	const getItemImageUrl = (itemId) => {
	  const id = itemId.toString()
	  
	  // Check cache first
	  if (itemImageCache[id]) {
		return itemImageCache[id]
	  }
	  
	  // Priority 1: Local shop config (if exists)
	  if (shop["eco"]?.[id]?.["img"]) {
		return shop["eco"][id]["img"]
	  }
	  
	  // Priority 2: Mapped file name (from your file list)
	  const mappedFile = ITEM_FILE_MAPPINGS[id]
	  if (mappedFile) {
		const url = `https://shop.derpe.xyz/items/${mappedFile}`
		// Cache it
		setItemImageCache(prev => ({...prev, [id]: url}))
		return url
	  }
	  
	  // Priority 3: Try the direct ID pattern as fallback
	  const baseUrl = `https://shop.derpe.xyz/items/${id}`
	  const fallbackUrl = baseUrl + '.png'
	  return fallbackUrl
	}
  
	// Function to get item name with fallbacks
	const getItemName = (itemId) => {
	  const id = itemId.toString()
	  
	  // Priority 1: Mapped name
	  if (ITEM_NAMES[id] && ITEM_NAMES[id].trim()) {
		return ITEM_NAMES[id]
	  }
	  
	  // Priority 2: Local shop config
	  if (shop["eco"]?.[id]?.["name"]) {
		return shop["eco"][id]["name"]
	  }
	  
	  // Fallback: Generic name
	  return `Item #${id}`
	}
  
	// Function to get item series for styling
	const getItemSeries = (itemId) => {
	  const id = parseInt(itemId)
	  if (id >= 60000) return "60000"
	  if (id >= 50000) return "50000"
	  if (id >= 40000) return "40000"
	  if (id >= 30000) return "30000"
	  if (id >= 20000) return "20000"
	  if (id >= 10000) return "10000"
	  return "100"
	}
  
	// Function to fetch supply data for a single item
	const getItemSupplyData = (itemId) => {
	  const id = itemId.toString()
	  
	  // Check cache first
	  if (itemSupplyCache[id]) {
		return Promise.resolve(itemSupplyCache[id])
	  }
	  
	  return items.methods.getItem(itemId)
		.call({from: address})
		.then((itemData) => {
		  const supplyData = {
			totalSupply: parseInt(itemData.totalSupply) || 0,
			maxSupply: parseInt(itemData.maxsupply) || 0,
			isLimited: itemData.maxsupply > 0
		  }
		  
		  // Cache the result
		  setItemSupplyCache(prev => ({...prev, [id]: supplyData}))
		  return supplyData
		})
		.catch((err) => {
		  console.error(`Error fetching supply for item ${itemId}:`, err)
		  // Return default values if fetch fails
		  const defaultData = {
			totalSupply: 0,
			maxSupply: 0,
			isLimited: false
		  }
		  setItemSupplyCache(prev => ({...prev, [id]: defaultData}))
		  return defaultData
		})
	}
  
	// Batch fetch supply data for multiple items
	const batchGetItemSupplyData = (itemIds) => {
	  const promises = itemIds.map(itemId => getItemSupplyData(itemId))
	  return Promise.all(promises)
	}
  
	// Load ALL items with their balances AND supply data
	const loadAllItemsData = () => {
	  if (!isConnected || !address) return
	  
	  setIsLoadingInventory(true)
	  
	  // Prepare arrays for batch call
	  const accounts = Array(ALL_ITEM_IDS.length).fill(address)
	  const ids = ALL_ITEM_IDS.map(id => id.toString())
	  
	  // Use balanceOfBatch to fetch all balances at once
	  items.methods.balanceOfBatch(accounts, ids)
		.call({from: address})
		.then((balances) => {
		  const newInventory = {}
		  const itemPromises = []
		  
		  balances.forEach((balance, index) => {
			const itemId = ids[index]
			const balanceNum = parseInt(balance)
			const itemName = getItemName(itemId)
			const itemCost = shop["eco"]?.[itemId]?.["cost"] || ''
			
			// For inventory tracking (non-zero only)
			if (balanceNum > 0) {
			  newInventory[itemId] = balanceNum
			}
			
			// Create promise for each item to fetch supply data
			itemPromises.push(
			  getItemSupplyData(itemId).then(supplyData => ({
				id: itemId,
				name: itemName,
				balance: balanceNum,
				cost: itemCost,
				series: getItemSeries(itemId),
				totalSupply: supplyData.totalSupply,
				maxSupply: supplyData.maxSupply,
				isLimited: supplyData.isLimited,
				supplyPercentage: supplyData.maxSupply > 0 
				  ? Math.round((supplyData.totalSupply / supplyData.maxSupply) * 100)
				  : null
			  }))
			)
		  })
		  
		  // Wait for all supply data to be fetched
		  return Promise.all(itemPromises)
		})
		.then((allItems) => {
		  // Sort by ID to maintain original order
		  allItems.sort((a, b) => parseInt(a.id) - parseInt(b.id))
		  
		  // Update inventory for owned items only
		  const newInventory = {}
		  allItems.forEach(item => {
			if (item.balance > 0) {
			  newInventory[item.id] = item.balance
			}
		  })
		  
		  setInventory(newInventory)
		  setAllItemsData(allItems)
		  setIsLoadingInventory(false)
		  console.log('All items with supply data loaded:', allItems)
		})
		.catch((err) => {
		  console.error('Error loading items with balanceOfBatch:', err)
		  setIsLoadingInventory(false)
		})
	}
  
	React.useEffect(() => {
	  if (isConnected && address) {
		getBal()
		loadAllItemsData()
	  }
	}, [isConnected, address])
  
	const ShopItem = (props) => (
	  <div className="shop-item" onClick={props.click}>
		<div className="shop-item-img">
		  <img src={props.itemImg} />
		</div>
		<div className="shop-item-info">
		  <div className="item-id">#{props.itemId}</div>
		  <div className="item-name">{props.itemName}</div>
		  <div className="item-cost">Cost: {props.itemCost} $DERP</div>
		  {inventory[props.itemId] > 0 && (
			<div className="item-owned">Owned: {inventory[props.itemId]}</div>
		  )}
		</div>
	  </div>
	)
  
	const InventoryItem = (props) => {
	  const [imageUrl, setImageUrl] = React.useState('')
	  const [imageLoaded, setImageLoaded] = React.useState(false)
	  const hasBalance = props.balance > 0
	  
	  React.useEffect(() => {
		// Get image URL
		const url = getItemImageUrl(props.itemId)
		setImageUrl(url)
	  }, [props.itemId])
	  
	  const handleImageError = () => {
		// If image fails, try a direct fallback
		const fallbackUrl = `https://shop.derpe.xyz/items/${props.itemId}.png`
		if (fallbackUrl !== imageUrl) {
		  setImageUrl(fallbackUrl)
		}
	  }
	  
	  const handleImageLoad = () => {
		setImageLoaded(true)
	  }
	  
	  const series = getItemSeries(props.itemId)
	  
	  return (
		<div 
		  className={`inventory-item ${!hasBalance ? 'inventory-item--zero' : ''}`} 
		  data-series={series}
		  data-has-balance={hasBalance}
		>
		  <div className="inventory-item-img">
			{imageUrl ? (
			  <img 
				src={imageUrl} 
				alt={props.itemName}
				onError={handleImageError}
				onLoad={handleImageLoad}
				loading="lazy"
				style={{ opacity: imageLoaded ? 1 : 0 }}
				className={!hasBalance ? 'image-greyscale' : ''}
			  />
			) : (
			  <div className="image-placeholder">Loading...</div>
			)}
			{!imageLoaded && imageUrl && (
			  <div className="image-loading">Loading...</div>
			)}
			{/* Balance indicator badge */}
			{hasBalance && (
			  <div className="balance-badge">{props.balance}</div>
			)}
			{/* Supply indicator for limited items */}
			{props.isLimited && props.maxSupply > 0 && (
			  <div className="supply-indicator">
				{props.totalSupply}/{props.maxSupply}
			  </div>
			)}
		  </div>
		  <div className="inventory-item-info">
			<div className="item-id">#{props.itemId}</div>
			<div className="item-name">{props.itemName}</div>
		
			
		
			
			
		  </div>
		</div>
	  )
	}
  
	const [isModalOpen, setIsModalOpen] = React.useState(false)
	const [activeModalID, setActiveModalID] = React.useState(0)
	
	const openItemModal = (itemID) => {
	  return () => {
		if (isConnected) {
		  setIsModalOpen(true)
		  setActiveModalID(itemID)
		} else {
		  alert("Please connect your wallet")
		}
	  }
	}
	
	const closeItemModal = () => {
	  setIsModalOpen(false)
	}
  
	React.useEffect(() => {
	  if (itemIds.indexOf(activeModalID) > -1 && isConnected) {
		getOnChainItemInfo()
	  }
	}, [activeModalID])
  
	const [onChainItemInfo, setOnChainItemInfo] = React.useState(null)
	const getOnChainItemInfo = () => {
	  items.methods.getItem(activeModalID)
		.call({from: address})
		.then((res)=>{
		  console.log(res)
		  setOnChainItemInfo(res)
		})
	}
  
	const getDerpBal = (callback = ()=>{}) => {
	  derpToken.methods.balanceOf(address)
		.call({from: address})
		.then((b)=>{
		  callback(b)
		})
	}
  
	const getDerpAllowance = (callback = ()=>{}) => {
	  derpToken.methods.allowance(address, networkConfig["derpPromoItems"]["address"])
		.call({from: address})
		.then((a)=>{
		  callback(a)
		})
	}
  
	const approveDerp = (callback = ()=>{}) => {
	  let spender = networkConfig["derpPromoItems"]["address"]
	  let amount = web3.utils.toWei(onChainItemInfo.derpCost,"ether")
	  let data = derpToken.methods.approve(spender,amount).encodeABI()
	  setPendingText("Approving $DERP")
	  sendRequest(
		networkConfig["derp"]["address"],
		data,
		callback)
	}
  
	const mint = (callback = ()=>{}) => {
	  let data = items.methods.mintItem(activeModalID).encodeABI()
	  setPendingText("Minting the Item")
	  sendRequest(
		networkConfig["derpPromoItems"]["address"],
		data,
		() => {
		  callback()
		  // Refresh inventory after minting
		  loadAllItemsData()
		}
	  )
	}
  
	const mintItem = () => {
	  items.methods.isLive()
		.call({from: address})
		.then((live)=>{
		  if (live) {
			items.methods.checkDerps(address,activeModalID)
			  .call({from: address})
			  .then((nextDerp)=>{
				console.log(nextDerp)
				if (nextDerp != 0 || (nextDerp == 0 && activeModalID > 10000) ) {
				  getDerpBal((balance)=>{
					let b = web3.utils.fromWei(balance, "ether")
					if (b >= Number(onChainItemInfo.derpCost)) {
					  getDerpAllowance((allowance)=>{
						let a = web3.utils.fromWei(allowance, "ether")
						if (a >= Number(onChainItemInfo.derpCost)) {
						  mint(()=>{
							
						  })
						} else {
						  approveDerp(()=>{
							mint(()=>{
							
							})
						  })
						}
					  })
					} else {
					  alert("Balance too low")
					}
				  })
				} else {
				  alert("you have no derps to claim for");
				}
			  })
		  } else {
			alert("minting is paused")
		  }
		})
	}
  
	// Get total items owned
	const getTotalInventoryCount = () => {
	  return Object.values(inventory).reduce((sum, balance) => sum + balance, 0)
	}
  
	// Get total unique items (including zero balance)
	const getTotalUniqueItems = () => {
	  return allItemsData.length
	}
  
	// Get count of items with balance > 0
	const getItemsWithBalanceCount = () => {
	  return allItemsData.filter(item => item.balance > 0).length
	}
  
	// Get total supply of all items
	const getTotalSupplyCount = () => {
	  return allItemsData.reduce((sum, item) => sum + item.totalSupply, 0)
	}
  
	// Get count of limited edition items
	const getLimitedItemsCount = () => {
	  return allItemsData.filter(item => item.isLimited).length
	}
  
	return (
	  <div className={"App App--" + isConnected + " App-chain--" + chainId}>
		<div className="lander">
		  <img src={fg} />
		</div>
		<div className="bg bg--color">
		  <div className="derp-items"><img src={derpeItems}/></div>  
		  
		  {/* Tab Navigation */}
		  <div className="tab-navigation">
			<button 
			  className={`tab-button ${activeTab === 'shop' ? 'active' : ''}`}
			  onClick={() => setActiveTab('shop')}
			>
			  SHOP
			</button>
			<button 
			  className={`tab-button ${activeTab === 'inventory' ? 'active' : ''}`}
			  onClick={() => {
				setActiveTab('inventory')
				loadAllItemsData() // Refresh inventory when switching to tab
			  }}
			>
			  INVENTORY ({getTotalInventoryCount()})
			</button>
		  </div>
  
		  {/* Shop Tab */}
		  {activeTab === 'shop' && (
			<div className="item-shop">
			  <div className="item-shop-inner">
				{itemIds.map((id,index)=>(
				  <ShopItem
					click={openItemModal(id)}
					itemId={id}
					itemImg={shop["eco"][id]["img"]}
					itemName={shop["eco"][id]["name"]}
					itemCost={shop["eco"][id]["cost"]}
				  />
				))}
			  </div>
			</div>
		  )}
  
		  {/* Inventory Tab */}
		  {activeTab === 'inventory' && (
			<div className="inventory-container">
			  <div className="inventory-header">
				<h2>Your Items</h2>
				<div className="inventory-controls">
				  <div className="inventory-stats">
					Total: {getTotalInventoryCount()} items | 
					Owned: {getItemsWithBalanceCount()}/{getTotalUniqueItems()} |
					Supply: {getTotalSupplyCount()} total |
					<label className="show-zero-toggle">
					  <input 
						type="checkbox" 
						defaultChecked
						onChange={(e) => {
						  document.body.classList.toggle('show-zero-balance', e.target.checked)
						}}
					  />
					  Show zero balance
					</label>
				  </div>
				  <button 
					className="refresh-button"
					onClick={loadAllItemsData}
					disabled={isLoadingInventory}
				  >
					{isLoadingInventory ? 'Loading...' : '🔄 Refresh'}
				  </button>
				</div>
			  </div>
			  
			  {isLoadingInventory ? (
				<div className="loading-inventory">
				  <p>Loading inventory and supply data...</p>
				</div>
			  ) : allItemsData.length === 0 ? (
				<div className="empty-inventory">
				  <p>No items found</p>
				</div>
			  ) : (
				<div className="inventory-grid">
				  {allItemsData.map((item) => (
					<InventoryItem
					  key={item.id}
					  itemId={item.id}
					  itemName={item.name}
					  cost={item.cost}
					  balance={item.balance}
					  totalSupply={item.totalSupply}
					  maxSupply={item.maxSupply}
					  isLimited={item.isLimited}
					  supplyPercentage={item.supplyPercentage}
					/>
				  ))}
				</div>
			  )}
			</div>
		  )}
  
		  <div className="dd"><img src={dd}/></div>
		  <div className="connect-button">
			<div className="inliner docs"><a href="https://docs.derpe.xyz" target="_blank">DOCS</a></div>
			<div className="inliner"><ConnectButton /></div>
		  </div>
  
		
  
		  <div className="links">
			<a href="https://discord.gg/3BUen4F9Tw" target="_blank"><img src={discord} /></a>
			<a href="https://t.me/derpedewdz" target="_blank"><img src={tg}/></a>
			<a href="https://x.com/derpedewdz" target="_blank"><img src={x}/></a>
		  </div>
  
		  <div className={"modal modal--" + isModalOpen}>
			<div className="close-button" onClick={closeItemModal}><img src={closeImg} /></div>
			<div className="modal-inner mint-box">
			  <div className="modal-item-img mint-gif">
				<img src={(activeModalID > 0) ? shop["eco"][activeModalID]["img"] : ""} />
			  </div>
			  <div className="modal-info">
				<p>ID #{(onChainItemInfo != null) ? onChainItemInfo.id : ""}</p>
				<p>Name: {(onChainItemInfo != null) ? onChainItemInfo.name : ""}</p>
				<p>Cost: {(onChainItemInfo != null) ? onChainItemInfo.derpCost : ""} $DERP</p>
				<p>Supply: {(onChainItemInfo != null) ? onChainItemInfo.totalSupply : ""}/{(onChainItemInfo != null) ? onChainItemInfo.maxsupply : ""}</p>
				<p>Per Derp Limit: {(onChainItemInfo != null) ? onChainItemInfo.perDerpLimit : ""}</p>
				<p>Description: {(onChainItemInfo != null) ? onChainItemInfo.description : ""}</p>
				{inventory[activeModalID] > 0 && (
				  <p>You own: {inventory[activeModalID]}</p>
				)}
			  </div>
			  <div className="mint-button"><button onClick={mintItem}>Mint</button></div>
			</div>
		  </div>
  
		  <div className={"pending pending--" + pending}>
			<p className="pending-title">Transaction Pending</p>
			<p className="pending-text">{pendingText}</p>
			<div className="pending-gif"><img src={pendingGif} /></div>
		  </div>
		</div>
	  </div>
	)
  }